import React from 'react';
import "./layout.css";
import SideMenu from "./SideMenu";
import {Outlet} from "react-router-dom";

const MenuTemplate = () => {
  
  return (<div className={"layout-menu"}>
    <SideMenu />
    <main className={"content"}>
      <Outlet />
    </main>
  </div>)
};

export default MenuTemplate;
